import { render, staticRenderFns } from "./retain-modal.vue?vue&type=template&id=71f05644&scoped=true&lang=pug&"
import script from "./retain-modal.vue?vue&type=script&lang=js&"
export * from "./retain-modal.vue?vue&type=script&lang=js&"
import style0 from "./retain-modal.vue?vue&type=style&index=0&id=71f05644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f05644",
  null
  
)

export default component.exports